module.exports = __webpack_public_path__ + "img/mars-stroke-right.8a16ad42.svg";